import { FormattedPhoneBookUser, NotificationStatus, ReportReason, UserFriendType, UserID } from "../../../../types";
import { receivedInvitationsPerPage } from "../../../context/NotificationsContext";
import api from "../../api";
import { serverPath } from "../../config";

export const saveFriend = (userId: UserID, friendId: UserID, blocked: boolean) =>
  api.put(serverPath.saveFriend, { userId, friendId, blocked });

export const updateFriend = (userId: UserID, friendId: UserID, blocked: boolean) =>
  api.patch(serverPath.updateFriend, { userId, friendId, blocked });

export const removeFriend = (userId: UserID, friendId: UserID) =>
  api.post(serverPath.removeFriend, { userId, friendId });

export const getUnBlockedFriends = async () => {
  const { data } = await api.get<UserFriendType[]>(serverPath.unblockedFriends);
  return data;
};
export const getBlockedFriends = async () => {
  const { data } = await api.get<UserFriendType[]>(serverPath.blockedFriends);
  return data;
};

export const inviteFriend = (fromUserId: number, toFriendId: number, channelName: string, videoPlatform: string) =>
  api.post(serverPath.inviteFriend, { fromUserId, toFriendId, channelName, videoPlatform });

export const generateLink = (fromUserId: number, invitationType: string) =>
  api.post(serverPath.generateLink, { fromUserId, invitationType });

export const decodeLink = (linkToDecode: string) => api.post(`${serverPath.decodeLink}?linkToDecode=${linkToDecode}`);

export const getReceivedInvitationsCount = () => api.get<number>(serverPath.receivedInvitationsCount);

let notificationsCount = 0;
export const getReceivedInvitations = async (page = 0) => {
  const { data } = await api.get(
    `${serverPath.receivedInvitations}?pageNumber=${page}&size=${receivedInvitationsPerPage}&sentBy=SOCKET`
  );

  if (page === 0) {
    const { data: count } = await getReceivedInvitationsCount();
    notificationsCount = count;
  }

  return {
    data: data || [],
    nextPage: page + 1,
    totalPages: Math.ceil(notificationsCount / receivedInvitationsPerPage),
  };
};

export const updateInvitation = (invitationId: number, invitationStatus: NotificationStatus) =>
  api.patch(serverPath.updateInvitation, { invitationId, invitationStatus });

export const reportUser = (userId: number, byUserId: number, type: ReportReason) =>
  api.put(serverPath.reportUser, { userId, byUserId, type });

export const sendBetaInvitations = (userId: number, fullName: string, anonymousUsers: FormattedPhoneBookUser[]) =>
  api.post(serverPath.sendBetaInvitations, {
    userId,
    fullName,
    appVersion: "BETA",
    anonymousUsers,
  });
